// 获取审核状态
//职称（1:教授；2:副教授；3：讲师；4:研究员；5:助教；6:其他；）
export const getzhichengStr = (status) =>{
    var str = "";
    switch (status) {
        case 0:
             str = '暂未设置'
            break;
        case 1:
            str = '教授'
            break;
        case 2:
            str = '副教授'
            break; 
        case 3:
            str = '讲师'
            break; 
        case 4:
            str = '研究院'
            break; 
        case 5:
            str = '助教'
            break;   
        case 6:
            str = '其他'
            break;
        default:
            break;
    }
    return str
}